import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

type Props = {
    onRetry: VoidFunction;
};

const RetryMessageStrategy = ({ onRetry }: Props) => {
    return (
        <IconButton
            type="flat"
            dataAutomation="retry-message-button"
            iconName="refresh"
            onClick={onRetry}
        >
            {translate("si.agent.leads.button.retry")}
        </IconButton>
    );
};

export default RetryMessageStrategy;
